import { render, staticRenderFns } from "./SettingsCountry.vue?vue&type=template&id=225f3874&"
import script from "./SettingsCountry.vue?vue&type=script&lang=js&"
export * from "./SettingsCountry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports